import { LegalSection, LegalShell } from "./LegalShell";

export function Terms() {
  return (
    <LegalShell title="Terms of Service" lastUpdated="May 24, 2026">
      <LegalSection heading="1. Acceptance of terms">
        <p>
          By accessing or using BeneCRM you agree to these Terms of Service. If
          you are using BeneCRM on behalf of an organization, you represent that
          you have authority to bind that organization to these terms.
        </p>
      </LegalSection>

      <LegalSection heading="2. The service">
        <p>
          BeneCRM is a workflow platform for employee-benefits brokerages,
          covering client promises, renewals, compliance tracking, and optional
          email and calendar integration with providers such as Microsoft 365.
        </p>
      </LegalSection>

      <LegalSection heading="3. Accounts and eligibility">
        <p>
          You are responsible for safeguarding your account credentials and for
          all activity under your account. BeneCRM is intended for business use
          by brokerage professionals.
        </p>
      </LegalSection>

      <LegalSection heading="4. Acceptable use">
        <p>
          You agree not to misuse the service, including attempting to access it
          by means other than the interfaces we provide, interfering with its
          operation, or using it to violate applicable law.
        </p>
      </LegalSection>

      <LegalSection heading="5. Third-party integrations">
        <p>
          When you connect a third-party account (for example, a Microsoft 365
          mailbox and calendar), you authorize BeneCRM to access that data to
          provide the relevant features. Your use of those services remains
          subject to their own terms.
        </p>
      </LegalSection>

      <LegalSection heading="6. Disclaimers and limitation of liability">
        <p>
          The service is provided &ldquo;as is&rdquo; without warranties of any
          kind. To the maximum extent permitted by law, BeneCRM is not liable for
          indirect or consequential damages arising from your use of the service.
        </p>
      </LegalSection>

      <LegalSection heading="7. Changes to these terms">
        <p>
          We may update these terms from time to time. Material changes will be
          communicated through the product or by email, and continued use after
          changes take effect constitutes acceptance.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact">
        <p>
          Questions about these terms can be sent to{" "}
          <a href="mailto:hello@benecrm.com" className="text-teal hover:underline">
            hello@benecrm.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalShell>
  );
}
